import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';

import Skeleton from 'components/Skeleton';
import { isTabletOrMobileDevice } from 'constants/app';
import { getMarketGraphIsSmallScreenView } from 'redux/modules/appConfigs/selectors';

import styles from './MarketGraphHeaderSkeleton.module.scss';

export default function MarketGraphHeaderSkeleton() {
  const navigate = useNavigate();

  const isSmallScreenView = useSelector(getMarketGraphIsSmallScreenView);

  const skeletonLeft = (
    <div className={styles.loading__left}>
      <Skeleton className={classNames(styles.loading__icon, styles.skeleton)} withBrandingClassName={false} />
      <Skeleton className={classNames(styles.loading__widget, styles.skeleton)} withBrandingClassName={false} />
      <div className={styles.loading__participants}>
        <Skeleton
          className={classNames(styles.loading__participants__item, styles.skeleton)}
          withBrandingClassName={false}
        />
        <Skeleton
          className={classNames(styles.loading__participants__item, styles.skeleton)}
          withBrandingClassName={false}
        />
      </div>
    </div>
  );

  return (
    <>
      {isTabletOrMobileDevice || isSmallScreenView ? (
        <div className={styles.loading__top}>
          {skeletonLeft}
          {isTabletOrMobileDevice && (
            <button className={styles.loading__top__btn} onClick={() => navigate(-1)}>
              <i className={classNames('fa2 fa2-cross-24', styles.loading__top__icon)} />
            </button>
          )}
        </div>
      ) : (
        skeletonLeft
      )}

      <Skeleton
        withBrandingClassName={false}
        className={classNames(styles.loading__right, styles.skeleton, {
          [styles.loading__right__mobile]: isTabletOrMobileDevice,
          [styles.loading__right__smallScreen]: isSmallScreenView
        })}
      />
    </>
  );
}
